import types from "../../../constants/action-types"

const defaultState = {
  latLang: "",
  openPopupId: "",
}

const map = {
  [types.SET_GEOLOCATION]: (state, { payload }) => ({
    ...state,
    latLang: payload,
  }),
  [types.OPEN_POPUP_ID]: (state, { payload }) => ({
    ...state,
    openPopupId: payload,
  }),
  [types.CLEAR_GEOLOCATION]: (state) => ({
    ...state,
    latLang: "",
    openPopupId: "",
  }),
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) =>
  (map[action.type] && map[action.type](state, action)) || state || defaultState
